/**
 * Change styles to slider buttons.
 */
 function tarjet_button_slider(){
    const tabs = document.querySelectorAll('[data-role="tab"]'),
    tabContents = document.querySelectorAll(".tab-panel");

    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const target = document.querySelector(tab.dataset.target);

            tabContents.forEach((tc) => {
            tc.classList.remove("is-active");
            });
            target.classList.add("is-active");

            tabs.forEach((t) => {
            t.classList.remove("is-active");
            });
            tab.classList.add("is-active");
        });
    });
}

tarjet_button_slider();

export default tarjet_button_slider;